<div class="role-assign-modal" ngbAutofocus>
  <div class="modal-header">
    <h5 class="modal-title">{{ editValue ? 'แก้ไขการมอบสิทธิ์ใช้งาน' : 'มอบสิทธิ์ใช้งานระบบ' }}</h5>
    <button type="button" class="btn-close" (click)="onCancel()" aria-label="ปิดหน้าต่าง"></button>
  </div>
  <div class="modal-body">
    <form [formGroup]="addForm">
      <!-- ผู้รับมอบสิทธิ์ -->
      <div class="mb-3">
        <label class="form-label">ผู้รับมอบสิทธิ์ <span class="text-danger">*</span></label>
        <div class="recipient-search">
          <input
            type="text"
            class="form-control"
            [(ngModel)]="recipientTaxId"
            [ngModelOptions]="{standalone: true}"
            (keydown.enter)="$event.preventDefault(); searchRecipient()"
            placeholder="เลขประจำตัวประชาชน 13 หลัก">
          <button type="button" class="btn btn-search" (click)="searchRecipient()"
                  [disabled]="searching() || !recipientTaxId.trim()">
            <i class="bi bi-search"></i>
            ค้นหาผู้ใช้
          </button>
        </div>
        @if (searching()) {
          <small class="recipient-hint">กำลังค้นหาข้อมูลผู้ใช้…</small>
        }
        @if (recipientError()) {
          <small class="recipient-error">{{ recipientError() }}</small>
        }
        <div class="recipient-name-field">
          <label class="form-label" for="recipient-name">ชื่อ-นามสกุล ผู้รับมอบสิทธิ์</label>
          <input
            id="recipient-name"
            type="text"
            class="form-control"
            [value]="selectedRecipient()?.name || ''"
            placeholder="ข้อมูลชื่อ-นามสกุลจะแสดงเมื่อค้นหาสำเร็จ"
            readonly>
        </div>
        <!-- resolved tax id used for validation/submit -->
        <input type="hidden" formControlName="assignee">
      </div>

      <!-- สิทธิ์ / การดำเนินงานที่มอบหมาย -->
      <div class="mb-3">
        <label class="form-label">สิทธิ์การดำเนินงานที่มอบหมาย <span class="text-danger">*</span></label>
        <div class="d-flex flex-column gap-2 mt-1 w-100">
          @for (opt of actionOptions(); track opt.action) {
            <div class="form-check w-100">
              <input
                type="checkbox"
                class="form-check-input"
                [id]="'action-' + opt.action"
                [checked]="isActionSelected(opt.action)"
                (change)="toggleAction(opt.action, $any($event.target).checked)">
              <label class="form-check-label" [for]="'action-' + opt.action">
                {{ opt.label }}
              </label>
            </div>
          }
        </div>
        @if (selectedActions().length === 0) {
          <small class="recipient-error">กรุณาเลือกสิทธิ์การดำเนินงานอย่างน้อย 1 รายการ</small>
        }
      </div>

      <!-- ธุรกิจและมาตรฐานที่มอบสิทธิ์ -->
      <div class="mb-3">
        <label class="form-label d-flex align-items-center justify-content-between">
          <span>ธุรกิจที่มอบสิทธิ์ <span class="text-danger">*</span>
            <small class="text-secondary fw-normal">— เลือกมาตรฐาน/ใบรับรองใต้ธุรกิจได้ถ้าต้องการจำกัด</small></span>
        </label>
        @if (loadingBusinesses()) {
          <small class="recipient-hint">กำลังโหลดข้อมูลธุรกิจและมาตรฐาน…</small>
        } @else if (businesses().length === 0) {
          <small class="recipient-error">ไม่พบข้อมูลธุรกิจสำหรับมอบสิทธิ์</small>
        } @else {
          <div class="business-options">
            @for (business of businesses(); track business.id) {
              <div class="business-group mb-2">
                <div class="form-check business-option">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    [id]="'biz-' + business.id"
                    [checked]="isBusinessSelected(business.id)"
                    (change)="toggleBusiness(business.id, $any($event.target).checked)">
                  <label class="form-check-label" [for]="'biz-' + business.id">
                    {{ business.title }}
                  </label>
                </div>

                @if (isBusinessSelected(business.id)) {
                  <div class="certificate-sublist ms-4 mt-2 ps-2 border-start">
                    @if (business.certificates.length === 0) {
                      <div class="text-secondary small py-1"><i class="bi bi-info-circle me-1"></i>ธุรกิจนี้ไม่มีมาตรฐาน/ใบรับรอง — มอบสิทธิ์ทั้งธุรกิจ</div>
                    } @else {
                      <div class="d-flex flex-column gap-1">
                        @for (cert of business.certificates; track certTrackKey(cert, $index); let i = $index) {
                          <div class="form-check certificate-option">
                            <input
                              type="checkbox"
                              class="form-check-input"
                              [id]="'cert-' + business.id + '-' + (cert.id || i)"
                              [checked]="isCertificateSelected(business, cert)"
                              (change)="toggleCertificate(business, cert, $any($event.target).checked)">
                            <label class="form-check-label" [for]="'cert-' + business.id + '-' + (cert.id || i)">
                              <span class="d-inline-flex align-items-baseline gap-1 flex-wrap">
                                @if (cert.standardCode) {
                                  {{ cert.standardCode }}
                                }
                                @if (cert.standardName) {
                                  <span>{{ cert.standardName }}</span>
                                } @else if (!cert.standardCode) {
                                  <span>{{ cert.label || 'มาตรฐาน' }}</span>
                                }
                              </span>
                            </label>
                          </div>
                        }
                      </div>
                      @if (!hasSelectedCertificate(business)) {
                        <small class="text-secondary d-block mt-1">
                          <i class="bi bi-info-circle me-1"></i>ไม่เลือก = มอบสิทธิ์ทุกมาตรฐานของธุรกิจนี้
                        </small>
                      }
                    }
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>

      <!-- ช่วงวันที่มอบสิทธิ์ — เว้นว่างไว้หมายถึงตลอดไป -->
      <div class="mb-3 date-range-group">
        <label class="form-label">ระยะเวลาการมอบสิทธิ์</label>
        <small class="date-hint">หากไม่ระบุวันที่ ระบบจะถือว่ามอบสิทธิ์อย่างต่อเนื่องจนกว่าจะมีการยกเลิก</small>
        <div class="date-range-row">
          <div class="date-field">
            <label class="form-label date-label">วันที่เริ่มต้น</label>
            <gt-ng-datepicker formControlName="startDate" inputSize="sm"></gt-ng-datepicker>
          </div>
          <div class="date-field">
            <label class="form-label date-label">วันที่สิ้นสุด</label>
            <gt-ng-datepicker formControlName="endDate" inputSize="sm"></gt-ng-datepicker>
          </div>
        </div>
      </div>

    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="onCancel()">
      ยกเลิก
    </button>
    <button type="button" class="btn btn-primary" (click)="onSave()" [disabled]="!canSubmit">
      บันทึกข้อมูล
    </button>
  </div>
</div>
